import { render } from "./c-cloud-model.vue?vue&type=template&id=05f0ac55"
import script from "./c-cloud-model.vue?vue&type=script&lang=js"
export * from "./c-cloud-model.vue?vue&type=script&lang=js"

import "./c-cloud-model.vue?vue&type=style&index=0&id=05f0ac55&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__